module.exports = __webpack_public_path__ + "img/18m2.e03024b3.jpg";